module.exports = __webpack_public_path__ + "img/InicioHion-lg.38c89d53.jpg";